module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-beach-6a7fb8ed92bbee39e465262faa320f02.svg";